import client from "../../auth/client";

export const getContractsReview = async () => {
  const res = await client.get("/doc_review/get_doc_review_data");
  return res.data;
};

export const getDocMetaData = async (reqBody: { doc_id: string }) => {
  const res = await client.post("/doc_review/extract_doc_metadata/", reqBody);
  return res.data;
};

export const getVmoBotResponse = async (reqBody: {
  files: string[];
  question: string;
  model: string;
}) => {
  const res = await client.post("/doc_review/chat_with_doc/", reqBody);
  return res.data;
};

export const deleteFilesFromGcs = async (reqBody: {
  file_names: string[];
  feature: "talk_to_contract";
}) => {
  const res = await client.post("delete_files_from_gcs/", reqBody);
  return res.data;
};

export const uploadFilesForRFxEvaluation = async (reqBody: FormData) => {
  const res = await client.post("/rfx_evaluation/upload_rfx_docs/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const evaluateRfxDocuments = async (reqBody: any) => {
  const res = await client.post(
    "/rfx_evaluation/evaluate_rfx_document/",
    reqBody
  );
  return res.data;
};
